import { FC } from 'react';
import { Spacer, Button, TextOverline, Stack } from '@pypestream/design-system';
import { TranslationComponent } from '@pypestream/translations';

import { GenericPopover, GenericPopoverProps } from '../generic-popover';

export type DeleteFilePopoverProps = GenericPopoverProps & {
  title?: string;
  onDelete?: () => void;
};

export const DeleteFilePopover: FC<DeleteFilePopoverProps> = ({
  trigger,
  popoverRef,
  testId,
  title,
  onClose,
  onDelete,
}) => {
  return (
    <GenericPopover
      width="auto"
      trigger={trigger}
      popoverRef={popoverRef}
      testId={testId}
    >
      <TextOverline variant="tertiary">{title}</TextOverline>
      <Spacer size="small" />
      <Stack direction="row" justifyContent="space-between" nowrap>
        <Button size="small" variant="secondary" width="full" onClick={onClose}>
          <TranslationComponent i18nKey="pro-studio/common:deleteFilePopover.cancel">
            Cancel
          </TranslationComponent>
        </Button>
        <Button
          size="small"
          variant="danger"
          width="full"
          onClick={() => {
            onDelete?.();
            onClose?.();
          }}
        >
          <TranslationComponent i18nKey="pro-studio/common:deleteFilePopover.delete">
            Delete
          </TranslationComponent>
        </Button>
      </Stack>
    </GenericPopover>
  );
};
